import { render, staticRenderFns } from "./ExpiredSkeleton.vue?vue&type=template&id=6e732ed5&scoped=true"
import script from "./ExpiredSkeleton.vue?vue&type=script&lang=js"
export * from "./ExpiredSkeleton.vue?vue&type=script&lang=js"
import style0 from "./ExpiredSkeleton.vue?vue&type=style&index=0&id=6e732ed5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e732ed5",
  null
  
)

export default component.exports